"use client";

import useScrollPosition from "@/hooks/use-scroll-position";
import { cn } from "@/lib/utils";

export function StickyHeader(props: { children: React.ReactNode }) {
  const scrollPosition = useScrollPosition();
  return (
    <header
      className={cn(
        scrollPosition > 0
          ? "bg-background/80 backdrop-blur-xl border-b border-border is-sticky"
          : "bg-transparent border-b border-transparent",
        "flex-none h-auto fixed z-20 top-0 inset-x-0 w-full transition-all duration-200 group",
      )}
    >
      {props.children}
    </header>
  );
}
